import { BaseModel } from './BaseModel';
import { WipeSchedule } from './WipeSchedule';

export class FileDeletion extends BaseModel {
    public id = '';
    public wipeScheduleId = '';
    public path = '';
    public createdAt = '';
    public updatedAt = '';

    get wipeSchedule(): WipeSchedule {
        return this.getRelationship('wipe_schedule');
    }

    getRouteName() {
        return 'file_deletion';
    }

    getRouteID() {
        return this.id;
    }
}
